import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMemo } from 'react';
import useBlogRSSFeedDataState from '../../hooks/useBlogRssFeedDataState';
import useEmailSelectedOptionState from '../../hooks/useEmailSelectedOptionState';
import useGetHasExistingBlogEmail from '../../hooks/useGetHasExistingBlogEmail';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateEmailPanelDoneButton({
  onClick
}) {
  const {
    selectedOption
  } = useEmailSelectedOptionState();
  const {
    blogID,
    frequency,
    rssFeedUrl
  } = useBlogRSSFeedDataState();
  const {
    hasExistingEmailForBlog,
    isLoadingHasExistingEmailForBlog
  } = useGetHasExistingBlogEmail({
    id: blogID,
    frequency
  });
  const canCreateEmail = useMemo(() => {
    if (selectedOption === 'BLOG_RSS') {
      return !isLoadingHasExistingEmailForBlog && (blogID && frequency || rssFeedUrl);
    }
    return selectedOption !== null;
  }, [selectedOption, isLoadingHasExistingEmailForBlog, blogID, frequency, rssFeedUrl]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "create-email-done-button",
    use: "primary",
    onClick: onClick,
    disabled: !canCreateEmail,
    children: hasExistingEmailForBlog ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management-creation.createEmailPanel.edit"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management-creation.createEmailPanel.next"
    })
  });
}